// Données NAP (Nom / Adresse / Téléphone) canoniques — source unique réutilisée
// dans le JSON-LD de chaque page de service. Identiques au head de public/index.html.

export const SITE_ORIGIN = 'https://www.alloreparations.com';

export const BUSINESS = {
  name: 'AlloRéparations',
  telephone: '+33983820754',
  smsPhone: '+33782373695',
  email: 'alloreparations@gmail.com',
  streetAddress: '7 place des Martyrs de la Résistance',
  addressLocality: 'Montpellier',
  postalCode: '34000',
  addressRegion: 'Occitanie',
  addressCountry: 'FR',
  latitude: 43.6106,
  longitude: 3.8773,
};

// Ligne coordonnées affichée en clair sur chaque page (reprise du docx).
export const CONTACT_LINE =
  'AlloRéparations — 7 place des Martyrs de la Résistance, 34000 Montpellier ' +
  '(centre-ville). Ouvert du lundi au samedi, 10h–20h non-stop, sans rendez-vous. ' +
  'Tél. 09 83 82 07 54 · SMS 07 82 37 36 95 · alloreparations@gmail.com.';

// Objet LocalBusiness réutilisable comme "provider" des Service (auto-suffisant
// pour le SEO local même sans le head statique de la home). Même @id que le head.
export const LOCAL_BUSINESS_LD = {
  '@type': 'ElectronicsStore',
  '@id': `${SITE_ORIGIN}/#business`,
  name: BUSINESS.name,
  image: `${SITE_ORIGIN}/logo.png`,
  url: `${SITE_ORIGIN}/`,
  telephone: BUSINESS.telephone,
  email: BUSINESS.email,
  priceRange: '€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: BUSINESS.streetAddress,
    addressLocality: BUSINESS.addressLocality,
    postalCode: BUSINESS.postalCode,
    addressRegion: BUSINESS.addressRegion,
    addressCountry: BUSINESS.addressCountry,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: BUSINESS.latitude,
    longitude: BUSINESS.longitude,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '20:00',
    },
  ],
  areaServed: [
    { '@type': 'City', name: 'Montpellier' },
    { '@type': 'AdministrativeArea', name: 'Hérault' },
    { '@type': 'AdministrativeArea', name: 'Occitanie' },
  ],
};
